import { feet, inches, cm } from './normalize';

import {
  isNotEmptyAnswer,
  isCheckboxAnswerNotEmpty,
  formatAnswer,
  formatHeightAnswer,
  formatDateAnswer,
  formatDropdownCheckboxAnswer,
  formatArrayAnswer,
  formatArrayWithColourAnswer,
  formatPrice,
  formatBooleanAnswer,
} from './format-answers';

import {
  restoreAnswer,
  restoreHeightAnswer,
  restoreMultiSelectAnswer,
  restoreDropdownWithPriceAnswer,
  restoreCheckboxAnswer,
} from './restore-answers';
import {
  restoreAddressAnswer,
  restoreAddressAnswerToString,
  formatAddressAnswerToString,
  formatFormattedAddressAnswerToString,
} from './address';

import {
  getFormAnswers,
  getAllQuestionsReduxNames,
  getParentQuestionsReduxNames,
  flatQuestionChildren,
  getSectionAnswers,
  getAddressAnswer,
  isComposedAnswer,
  getComposedAnswer,
  composeAnswer,
} from './question-helpers';

import {
  DEFAULT_ERROR_MESSAGE,
  POSTCODE_INVALID_ERROR_MESSAGE,
  requiredMultiply,
  requiredAge,
  requiredHeight,
  required,
  requiredWithMessage,
  requiredCheckbox,
  requiredDropdown,
  validateEventDate,
  validateGBPostcode,
  validatePhoneNumberUKMobile,
  validateDateExcess,
  validateSomeoneElseName,
  validateDate,
  validateEmail,
} from './validation-helpers';

import {
  parse,
  parseCheckbox,
  parseMultiSelect,
  format,
  formatCheckbox,
  getQuestionNameFromFieldName,
  formatValueToString,
} from './reduxField-helpers';

export const normalize = {
  feet,
  inches,
  cm,
};

export const formatAnswers = {
  isNotEmptyAnswer,
  isCheckboxAnswerNotEmpty,
  formatAnswer,
  formatHeightAnswer,
  formatDateAnswer,
  formatDropdownCheckboxAnswer,
  formatArrayAnswer,
  formatArrayWithColourAnswer,
  formatPrice,
  formatBooleanAnswer,
};

export const restoreAnswers = {
  restoreHeightAnswer,
  restoreAnswer,
  restoreMultiSelectAnswer,
  restoreDropdownWithPriceAnswer,
  restoreCheckboxAnswer,
  restoreAddressAnswer,
  restoreAddressAnswerToString,
};

export const questionHelpers = {
  getFormAnswers,
  formatAddressAnswerToString,
  formatFormattedAddressAnswerToString,
  getAllQuestionsReduxNames,
  getParentQuestionsReduxNames,
  flatQuestionChildren,
  getSectionAnswers,
  getAddressAnswer,
  isComposedAnswer,
  getComposedAnswer,
  composeAnswer,
};

export const validation = {
  DEFAULT_ERROR_MESSAGE,
  POSTCODE_INVALID_ERROR_MESSAGE,

  required,
  requiredWithMessage,
  requiredMultiply,
  requiredAge,
  requiredHeight,
  requiredCheckbox,
  requiredDropdown,

  validateEventDate,
  validateGBPostcode,
  validatePhoneNumberUKMobile,
  validateDateExcess,
  validateSomeoneElseName,
  validateDate,
  validateEmail,
};

export const reduxFieldHelpers = {
  parse,
  parseCheckbox,
  parseMultiSelect,
  format,
  formatCheckbox,
  getQuestionNameFromFieldName,
  formatValueToString,
};

export { buildRawQuestion, JRNI_QUESTION_TYPE, OCAB_QUESTION_TYPE, SelectType } from './builder';
